const PRODUCTS_BASE = '/products';
const CARDS_BASE = PRODUCTS_BASE + '/cards';
const PAYMENTS_BASE = PRODUCTS_BASE + '/payments';
const ACCOUNTS_BASE = PRODUCTS_BASE + '/accounts';
const REPORTS_BASE = '/reports';
const SIRCUPA_BASE = '/sircupa';
const IIBBTUCUMAN_BASE = '/iibbTucuman';
const REMUNERATED_BASE = ACCOUNTS_BASE + '/remunerated';

const ACCOUNTS = {
    BASE: ACCOUNTS_BASE,
    LIST: ACCOUNTS_BASE + '/accounts',
    TRANSACTIONS: ACCOUNTS_BASE + '/transactions',
    REMUNERATED: REMUNERATED_BASE,
    INVESTMENT_OPERATIONS: REMUNERATED_BASE + '/investments',
    EARNINGS_SETTLEMENT: ACCOUNTS_BASE + '/earningsSettlement',
};
const CARDS = {
    BASE: CARDS_BASE,
    COLLECTIONS: CARDS_BASE + '/collections',
    ACTIVITY: CARDS_BASE + '/activity',
    SUMMARIES: CARDS_BASE + '/summaries',
    EXPIRATIONS: CARDS_BASE + '/expirations',
    CANCELLATIONS: CARDS_BASE + '/cancellations',
    MOVEMENTS: CARDS_BASE + '/movements',
};

const PAYMENTS = {
    BASE: PAYMENTS_BASE,
    LINKS: PAYMENTS_BASE + '/links',
    MOVEMENTS: PAYMENTS_BASE + '/movements',
    CHARGEBACKS: PAYMENTS_BASE + '/chargebacks',
};

const PRODUCTS = {
    BASE: PRODUCTS_BASE,
    CARDS,
    PAYMENTS,
    ACCOUNTS,
};

const REPORTS = {
    BASE: REPORTS_BASE + '/exempts',
    AFIP: REPORTS_BASE + '/afip',
    ACCOUNTING_ENTRIES: REPORTS_BASE + '/journalEntries',
    BANK_RECONCILIATION: REPORTS_BASE + '/bankReconciliation',
    BCRA_CUSTOMER_ACCOUNTS: REPORTS_BASE + '/bcraCustomerAccounts',
    IDC_EXEMPT: REPORTS_BASE + '/idcExempt',
    BCRA_STATISTICAL_INF: REPORTS_BASE + '/bcraStatisticalInf',
    BILLS: REPORTS_BASE + '/bills',
    BILLS_CALENDAR: REPORTS_BASE + '/bills/calendar',
    DAILY_BALANCES: REPORTS_BASE + '/dailyBalances',
    SIRCUPA: REPORTS_BASE + SIRCUPA_BASE,
    SIRCUPA_TAX_REGISTERS: REPORTS_BASE + SIRCUPA_BASE + '/taxRegisters',
    SIRCUPA_RETURNS: REPORTS_BASE + SIRCUPA_BASE + '/returns',
    IIBBTUCUMAN: REPORTS_BASE + IIBBTUCUMAN_BASE,
    IIBBTUCUMAN_TAX_REGISTERS: REPORTS_BASE + IIBBTUCUMAN_BASE + '/taxRegisters',
};

const MANAGEMENT = {
    BASE: '/management',
    CHECKER: '/management/checker',
    FUNCTIONALITIES: '/management/functionalities',
    CONSULTANTS: '/management/consultants',
    NOTIFICATIONS: '/management/notifications',
    PAYMENT_LINKS_RULES: '/management/rules/paymentLinks',
    TRANSFERS_RULES: '/management/rules/transfers',
    EDIT_RULES: '/management/rules/editRules',
    EXCEPTION_REQUESTS: '/management/rules/exceptionRequests',
};

const AUTH_BASE = '/auth';
const AUTH = {
    BASE: AUTH_BASE,
    LOGIN: AUTH_BASE + '/login',
    OTP: AUTH_BASE + '/otp',
    PASSWORD: AUTH_BASE + '/password',
    REGISTRATION: AUTH_BASE + '/registration',
    FORGOT_PASSWORD: AUTH_BASE + '/forgot-password',
};

const CLIENTS_BASE = '/clients';
const CLIENTS_DETAILS_BASE = CLIENTS_BASE + '/details';

const CLIENTS = {
    BASE: CLIENTS_BASE,
    DETAILS: CLIENTS_DETAILS_BASE,
    ADDRESS: CLIENTS_DETAILS_BASE + '/address',
    EMAIL: CLIENTS_DETAILS_BASE + '/email',
    MOBILE: CLIENTS_DETAILS_BASE + '/mobile',
    DEVICE: CLIENTS_DETAILS_BASE + '/device',
    ACCOUNTS_POSITION: CLIENTS_BASE + '/accountsPosition',
    PAYMENT_LINKS_POSITION: CLIENTS_BASE + '/paymentLinksPosition',
    AUDIT: CLIENTS_BASE + '/audit',
    CARD: CLIENTS_BASE + '/card',
};

const USERS = {
    BASE: '/users',
};

export const ROUTES = {
    HOME: '/',
    DASHBOARD: '/dashboards',
    AUTH,
    PRODUCTS,
    REPORTS,
    MANAGEMENT,
    CLIENTS,
    USERS
};
